import toast from 'react-hot-toast';
import { axiosInstance } from './axios';



export const Signup = async (username,password) => {
 
    const response = await axiosInstance.post(`auth.php?username=${username}&password=${password}&action=register`);
        
        return response.data;
    
    };
    
  
    export const Signin = async (data) => {
     
    const response = await axiosInstance.post(`signin.php`,data);
        
    return response.data;
    
    };
    
  export const SignOut = async () => {
     
    const response = await axiosInstance.post(`LogOut.php`);
        
    console.log(response)
    return response.data;
    
    };


export const Get = async (token,api,others) => {
    
    try{
    const response = await axiosInstance.get(`${api}?${others}`,{
        //...data
        },{
        //Adding token to the request
        
});

    return response.data;

    }catch(error){

     toast.error(`Error in Get ${api}`);
      console.log(`Error in Get ${api}:`, error);

        return null;
    }

};



export const Post = async (token,api,data) => {
    
 try{
    const response = await axiosInstance.post(`${api}`, data );
    return response.data;
    
}catch(error){

     toast.error(`Error in Get ${api}`);
      console.log("Logout error:", error);

        return null;
    }
    
};








    
export const GET = async (token,api,others) => {

    const url = others ? `${api}?${others}` : api;
  
    const response = await axiosInstance.get(url);

    return response;

  
};



export const POST = async (token,api,data) => {

    const response = await axiosInstance.post(`${api}`, data );
    return response;
    

    
};




export const UPDATE = async (token,api,data) => {
   
    const response = await axiosInstance.put(`${api}`, data);

    return response;
   
};



export const DELETE = async (token,api,data) => {
   
    const response = await axiosInstance.delete(`${api}`, {data:data});

    return response;

  
};






























